<template>
  <Modal
    v-model="_value"
    width="500"
    title="查看/修改SIM卡信息"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="loginForm" :model="simInfo" :rules="rules" style="display: inline;" :label-width="120">
      <FormItem prop="simNum" label="SIM卡号码">
        <Input style="display: inline-block; " :disabled="!modify" v-model="simInfo.simNum" placeholder="请输入SIM卡号码">
        </Input>
      </FormItem>
      <FormItem prop="simShortNum" label="SIM卡11位号码">
        <Input :disabled="!modify" v-model="simInfo.simShortNum" placeholder="请输入SIM卡11位号码">
        </Input>
      </FormItem>
      <FormItem prop="iccid" label="ICCID">
        <Input style="display: inline-block;" :disabled="!modify" v-model="simInfo.iccid" placeholder="请输入ICCID">
        </Input>
      </FormItem>
      <FormItem prop="operation" label="电信运营商">
        <Select :disabled="!modify" placeholder="选择电信运营商" style="display: inline-block;"
                v-model="simInfo.operation"
        >
          <Option v-for="(option, index) in simOperationOptions" :value="option.value" :key="option.label">{{option.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="state" label="SIM卡状态">
        <Select :disabled="!modify" placeholder="选择SIM卡状态" style="display: inline-block;"
                v-model="simInfo.state"
        >
          <Option v-for="(option, index) in simStateOptions" :value="option.value" :key="option.label">{{option.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="remark" label="备注">
        <Input :disabled="!modify" type="textarea" v-model="simInfo.remark" placeholder="备注">
        </Input>
      </FormItem>
    </Form>
    <Row style="text-align: right;">
      <i-switch v-model="modify" @on-change="modifyChange" size="large">
        <span slot="open">保存</span>
        <span slot="close">修改</span>
      </i-switch>
    </Row>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'SimInfoDetailModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    simNumRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: 'SIM卡号码不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {
      modify: false,
      simStateOptions: [
        { label: '未安装', value: 0 },
        { label: '已安装', value: 1 },
        { label: '停用', value: 2 }
      ],
      simOperationOptions: [
        { label: '中国移动', value: 1 },
        { label: '中国联通', value: 2 },
        { label: '中国电信', value: 3 },
        { label: '珠海移动专网', value: 4 },
        { label: '中国移动-东莞中智', value: 5 },
        { label: '中国移动-佛山交协', value: 6 },
        { label: '中国电信-中山邦悦', value: 7 },
        { label: '中国移动-河北九宸', value: 8 },
        { label: '中国移动-中山邦悦', value: 9 },
        { label: '中国联通-中山邦悦', value: 10 },
        { label: '中国移动-深圳晓聪', value: 11 }
      ],
      simInfo: {
        id: null,
        simNum: null,
        simShortNum: null,
        iccid: null,
        remark: null
      }
    }
  },
  methods: {
    ...mapActions([
      'SimInfoServ_GetDetail',
      'SimInfoServ_ModifyObj'
    ]),
    modifyChange (status) {
      if (status === false) {
        this.$Modal.confirm({
          title: '确认修改SIM卡信息',
          content: '<p>确认修改SIM卡信息</p>',
          onOk: () => {
            store.dispatch('SimInfoServ_ModifyObj', {
              params: this.simInfo
            }).then(() => {
              this.$Message.success('修改成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          },
          onCancel: () => {
            let simInfoId = this._initValue
            store.dispatch('SimInfoServ_GetDetail', {
              params: { id: simInfoId }
            }).then(() => {
              this.simInfo = store.getters.get_SimInfo_GetDetailResult
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        })
      }
    },
    visibleChange (val) {
      if (val) {
        this.modify = false
        this.id = null
        this.simInfo.simNum = null
        this.simInfo.simShortNum = null
        this.simInfo.iccid = null
        this.simInfo.remark = null
        let simInfoId = this._initValue
        if (simInfoId) {
          store.dispatch('SimInfoServ_GetDetail', {
            params: { id: simInfoId }
          }).then(() => {
            this.simInfo = store.getters.get_SimInfo_GetDetailResult
          }).catch(err => {
            this.$Message.error(err)
          })
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        simNum: this.simNumRules
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
